import EmailContainer from "./EmailContainer";

export default EmailContainer;
